module.exports = __webpack_public_path__ + "img/img_nodata.aeaa212a.png";